import React from 'react';
import './Hero.css';
import PlayIcon from '../../shared/PlayIcon';

const Hero = () => (
  <section className="hero">
    <div className="hero-mesh"></div>
    <div className="hero-grid"></div>
    <div className="hero-badge fu0">
      <span className="badge-dot" style={{width:7,height:7,background:'var(--calmTeal)',borderRadius:'50%',display:'block'}}></span>
      Early Access · Now on Android
    </div>
    <h1 className="fu1">Payments that<br/><span className="grad-text">move at your speed</span></h1>
    <p className="hero-sub fu2">SequPay brings enterprise-grade security and consumer-grade ease to every transaction. Your all-in-one digital payments &amp; financial services platform — built for India and beyond.</p>
    <div className="hero-notice fu3">
      ⚡ <strong>Early Access Preview</strong> — We are actively building integrations with banking partners, payment networks, and financial service providers. Features activate progressively as regulatory approvals and integrations go live.
    </div>
    <div className="dl-wrap fu4" id="dl-section">
      <div className="dl-label">Download Free</div>
      <div className="dl-btns">
        <a href="https://play.google.com/store/apps/details?id=com.sequspace.sequpay" className="btn-play" target="_blank" rel="noopener noreferrer">
          <PlayIcon />
          <div className="btn-play-lbl"><small>GET IT ON</small><strong>Google Play</strong></div>
        </a>
        <div className="btn-soon">
          <span className="soon-tag">Soon</span>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"/><path d="M12 2C9 6 7.5 9 7.5 12C7.5 15 9 18 12 22"/><path d="M12 2C15 6 16.5 9 16.5 12C16.5 15 15 18 12 22"/><path d="M2 12H22"/></svg>
          <div className="btn-play-lbl"><small>COMING TO</small><strong>App Store</strong></div>
        </div>
      </div>
      <div className="dl-note"><span className="dl-line"></span>Free · No credit card required<span className="dl-line"></span></div>
    </div>
  </section>
);

export default Hero;
